<template>
    <div class="tabs">
        <div v-for="(item, idx) in items" :key="idx" class="tab" :class="current == idx ? 'active' : ''"
            @click="onClickItem(idx)">
            {{ item }}
        </div>
    </div>
</template>

<script>
export default {
    name: "tabs",
    props: {
        items: {
            type: Array
        },
        current: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
        };
    },
    methods: {
        onClickItem(idx) {
            if (this.current != idx) {
                this.$emit("change", idx);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.tabs {
    height: 44px;
    display: flex;
    align-items: center;
    border-radius: var(--radius-sm);
    background: rgba(255, 252, 243, 0.5);
    border: 0.5px solid var(--hairline-soft);
    padding: 4px;
    position: relative;

    .tab {
        color: var(--im-text-color-secondary);
        padding: 8px 16px;
        border-radius: var(--radius-xs);
        font-weight: 500;
        font-size: 14px;
        flex: 1;
        text-align: center;
        white-space: nowrap;
        cursor: pointer;
        transition: all 0.18s cubic-bezier(0.32, 0.72, 0, 1);
        position: relative;
        z-index: 1;
        
        &:hover {
            color: var(--im-text-color-primary);
            background: var(--im-background-active);
        }

        &.active {
            color: var(--aurora-blue);
            background: var(--im-background-active-dark);
            box-shadow: inset 0 1px 0 0 rgba(255,255,255,0.8), 0 2px 8px rgba(91, 141, 238, 0.12);
            font-weight: 600;
            transform: translateY(-1px);

            // 添加下划线指示器
            &::after {
                content: '';
                position: absolute;
                bottom: -2px;
                left: 50%;
                transform: translateX(-50%);
                width: 24px;
                height: 2px;
                background: linear-gradient(90deg, var(--aurora-blue), var(--aurora-purple));
                border-radius: 2px;
                animation: slideIn 0.24s ease-out;
            }
        }

        &:active {
            transform: translateY(0) scale(0.98);
            transition: transform 0.1s ease;
        }

        // 第一个和最后一个tab的特殊处理
        &:first-child {
            margin-right: 2px;
        }

        &:last-child {
            margin-left: 2px;
        }

        // 中间的tab
        &:not(:first-child):not(:last-child) {
            margin: 0 2px;
        }
    }
}

// 下划线出现动画
@keyframes slideIn {
    0% {
        width: 0;
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        width: 24px;
        opacity: 1;
    }
}
</style>